import { Permission, SecurityScope } from '../../auth/auth.model';
import { AuthService } from '../../auth/auth.service';
import { epicDependencies } from '../../store';

import { AllowedActions } from './allowed-actions.model';

export function determineAllowedActions(): AllowedActions {
    const service = epicDependencies.injector.get<AuthService>(AuthService); // TODO FIXME revise

    const canViewTranscriptSummaryTab = service.user.hasPermission(
        Permission.COACHING_VIEW_TRANSCRIPT_SUMMARY_TAB,
        SecurityScope.COACHING,
    );

    return {
        viewTranscriptSummaryTab: canViewTranscriptSummaryTab,
    };
}
